import { updatePostUseCase } from "../../shared/useCases/post/updatePostUseCase"; 
import type { GetPostStore } from "../../shared/useCases/post/updatePostUseCase"

const getMainPostUseCase = (store: GetPostStore) =>{
    return updatePostUseCase(store, true );
}

export { getMainPostUseCase };